import { Paper } from "../../types/Paper";
import { extractDate } from "../DateTime/ExtractDate";

export function formatPaperFromResponse(response: any): Paper[] {
  return response.map((paper: any) => {
    return {
      id: paper.id,
      name: paper.name,
      created_at: extractDate(paper.created_at)
    }
  });
}
